import React, { useMemo } from 'react';
import './styles.css';
import BasicButton from '../../../BasicButton';

const ListActionControls = props => {
  const { actionButtonControls } = props;

  const cls = useMemo(
    () =>
      actionButtonControls.filter(a => !a.hidden).length < 7
        ? 'list-action-controls list-action-controls--compact'
        : 'list-action-controls',
    [actionButtonControls]
  );

  return (
    <div className={cls}>
      {actionButtonControls
        .filter(a => !a.hidden)
        .map((control, index) => (
          <div key={index} className="list-action-controls__button">
            <BasicButton
              disabled={control.disabled}
              btnWidth={150}
              btnHeight={35}
              btnFontSize="0.8571rem"
              btnFontWeight={600}
              btnText={control.caption}
              btnArrow={false}
              btnBg="#fff"
              btnHoverBg="#f40"
              controlFunc={control.controlFunc}
            />
          </div>
        ))}
    </div>
  );
};

export default ListActionControls;
